import http from "@/service/util/http.js";
export default {
  name: "ApiExplorer",
  props: ["parent"],
  data() {
    return {
      optMethod: "get",
      optUrl: "",
      optData: "",
      optResult: "",
      optApiList: "",
      dataSource: [],
    };
  },
  mounted() {
    http.get("", "").then((res) => {
      //res.filter(     )
      this.optApiList = JSON.stringify(res.data.links, ["rel"], 4);
    });
  },
  methods: {
    onAction() {
      var that = this;
      switch (that.optMethod) {
        case "get":
          http
            .get(that.optUrl, that.optData ? JSON.parse(that.optData) : "")
            .then((res) => {
              that.optResult = JSON.stringify(res, null, 4);
              if (res.data.content) that.dataSource = res.data.content;
              else that.dataSource = res.data;
            })
            .catch((e) => {
              that.optResult = e;
            });
          break;
        case "post":
          http
            .post(that.optUrl, that.optData ? JSON.parse(that.optData) : "")
            .then((res) => {
              that.optResult = JSON.stringify(res, null, 4);
            })
            .catch((e) => {
              that.optResult = e;
            });
          break;
        case "patch":
          http
            .patch(that.optUrl, that.optData ? JSON.parse(that.optData) : "")
            .then((res) => {
              that.optResult = JSON.stringify(res, null, 4);
            })
            .catch((e) => {
              that.optResult = e;
            });
          break;
        case "delete":
          http
            .delete(that.optUrl, that.optData ? JSON.parse(that.optData) : "")
            .then((res) => {
              that.optResult = JSON.stringify(res, null, 4);
            })
            .catch((e) => {
              that.optResult = e;
            });
          break;

        default:
          break;
      }
    },
    close() {
      this.$modal.hideAll();
      //this.parent.$emit("close");
    },
    onSelectionChanged(e) {
      //-- console.log(e);
      this.optUrl = "/" + e.addedItems[0];
    },
  },
  computed: {
    APiList: function() {
      if (this.optApiList && Array.isArray(JSON.parse(this.optApiList))) {
        var arr = JSON.parse(this.optApiList);
        var arrReturn = arr.map((data) => {
          return data.rel;
        });
        return arrReturn;
      } else return [];
    },
  },
};
